import React from 'react';
import PropTypes from 'prop-types';
import formatMessage from 'format-message';
import { RESOURCES_STATS as searchPath } from '../../../constants/search-paths';
import { STATS_PAGE_SIZE as resultsPerPage } from '../../../constants/paginated-page-sizes';
import { createFetchResults } from '../../../common/util/create-fetch-results';
import { hasActiveSearch } from '../../../common/util/search-query-utils';

// Components
import NoResult from '../../common/no-result';
import Loading from '../../common/loading';
import TableObjects from './table-objects';

const fetchResults = createFetchResults(searchPath, resultsPerPage);

export default class AccountStats extends React.Component {
  static displayName = 'AccountStats'

  static propTypes = {
    session: PropTypes.object.isRequired,
    groups: PropTypes.object
  }

  render () {
    const { isAdmin, isAccountCurator = false } = this.props.session;
    const { groups, results } = this.props;
    if (groups.listIsLoading) {
      return (
        <div className="AppHandler--loading">
          <Loading />
        </div>
      );
    }

    const isAllowed = isAdmin || isAccountCurator;
    const baseParams = isAllowed
      ? {}
      : {
        scopeIds: groups.list
          .filter(({ isManager }) => isManager)
          .map(({ id }) => 'group-' + id)
      };

    const hasResults = Boolean(results.total);
    const noResultsMessage = hasResults
      ? formatMessage('No Results Found')
      : formatMessage('No Stats to Show');

    const showSuggestions = hasResults && hasActiveSearch(this.props.router.query);

    return (
      <TableObjects
        baseParams={baseParams}
        fetchResults={fetchResults}
        searchPrivateObjects={false}
        resultsPerPage={resultsPerPage}
        emptyMessage={
          <NoResult title={noResultsMessage} showSuggestions={showSuggestions} />
        }
        {...this.props}
      />
    );
  }
}
